var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawTextField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.8958 101.85H59.3583V59.8583H75.975V63.9375C75.975 66.356 77.9356 68.3167 80.3542 68.3167C82.7727 68.3167 84.7333 66.356 84.7333 63.9375V55.4792C84.7333 53.0606 82.7727 51.1 80.3542 51.1H29.6042C27.1856 51.1 25.225 53.0606 25.225 55.4792V63.9375C25.225 66.356 27.1856 68.3167 29.6042 68.3167C32.0227 68.3167 33.9833 66.356 33.9833 63.9375V59.8583H50.6V101.85H38.0625C35.644 101.85 33.6833 103.811 33.6833 106.229C33.6833 108.648 35.644 110.608 38.0625 110.608H71.8958C74.3144 110.608 76.275 108.648 76.275 106.229C76.275 103.811 74.3144 101.85 71.8958 101.85ZM101.35 55.4792C101.35 57.8977 103.311 59.8583 105.729 59.8583H156.479C163.403 59.8583 169.017 65.4716 169.017 72.3958V140.062C169.017 146.987 163.403 152.6 156.479 152.6H54.9792C48.0549 152.6 42.4417 146.987 42.4417 140.062V131.604C42.4417 129.186 40.481 127.225 38.0625 127.225C35.644 127.225 33.6833 129.186 33.6833 131.604V140.062C33.6833 151.824 43.2178 161.358 54.9792 161.358H156.479C168.241 161.358 177.775 151.824 177.775 140.062V72.3958C177.775 60.6345 168.241 51.1 156.479 51.1H105.729C103.311 51.1 101.35 53.0606 101.35 55.4792Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawTextField);
export default __webpack_public_path__ + "static/media/draw-text-field.62e433995f719fd3c9afb68f9c85fb3d.svg";
export { ForwardRef as ReactComponent };